import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window.console.log = window.console.error = window.console.info = function() {};  // limpiar los console.log , console.error y console.inf
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
